import React, { Fragment } from 'react';
import { Icon, Checkbox, Typography, Tooltip } from '@firesoon/antd';
import { Drag } from '@firesoon/icons-react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import Button from '../../Button';

const groupName = {
  left: '固定在左侧',
  center: '不固定',
  right: '固定在右侧',
};

const FixIcon = ({ title, icon, config = {} }) => (
  <Tooltip
    title={title}
    overlayStyle={{ minWidth: `calc(${title.length}em + 16px)` }}
    getPopupContainer={(node) => node.parentElement || document.body}
    {...config}
  >
    {icon}
  </Tooltip>
);

const Menu = ({
  selectCols,
  handleCol,
  resetCols,
  saveCols,
  handleGroup,
  onDragEnd,
  checkAll,
  indeterminate,
  onCheckAllChange,
}) => {
  const keys = Object.keys(selectCols);

  return (
    <div className="fs-table-col-set">
      <div className="header">
        <div className="title">表头自定义</div>
        <div>
          <Button type="link" className="reset" onClick={resetCols}>
            取消
          </Button>
          <Button type="link" onClick={saveCols}>
            保存
          </Button>
        </div>
      </div>

      <div className="body">
        <div className="selectAll">
          <Checkbox
            checked={checkAll}
            indeterminate={indeterminate}
            onChange={(e) => onCheckAllChange(e.target.checked)}
          >
            全选
          </Checkbox>
        </div>
        <DragDropContext onDragEnd={onDragEnd}>
          {keys.map((item) => (
            <Fragment key={item}>
              {selectCols[item].filter((col) => col.title && !col.noCustom).length > 0 && (
                <div className="group-name">{groupName[item]}</div>
              )}

              <Droppable droppableId={item} type={item}>
                {(provided) => (
                  <div className="fs-table-dropdown-menu" {...provided.droppableProps} ref={provided.innerRef}>
                    {selectCols[item].map((col, index) => {
                      const isFixed = col.fixed === 'left' || col.fixed === 'right';

                      // 由于拖拽返回只能返回index, 所以不要改变数组长度
                      if (!col.title || col.noCustom) {
                        return null;
                      }

                      return (
                        <Draggable key={col.dataIndex} draggableId={col.dataIndex} index={index}>
                          {(provided) => (
                            <div
                              className="fs-table-dropdown-menu-item"
                              ref={provided.innerRef}
                              title={col.title}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                            >
                              <Drag style={{ marginRight: 4, color: '#999' }} />
                              <Checkbox
                                checked={!col.isHide}
                                onChange={(e) => {
                                  handleCol(e.target.checked, col);
                                }}
                                disabled={col.noCustom}
                              >
                                <Typography.Paragraph
                                  ellipsis
                                  style={{
                                    color: col.noCustom ? '#999' : '',
                                  }}
                                  // 修复父级节点title属性导致埋点数据采集被重复采集
                                  data-auto-track={false}
                                >
                                  {col.title}
                                </Typography.Paragraph>
                              </Checkbox>

                              <div className="icons">
                                {isFixed && (
                                  <FixIcon
                                    icon={
                                      <Icon
                                        type="vertical-align-middle"
                                        onClick={() => handleGroup(item, 'center', col, index)}
                                      />
                                    }
                                    title={groupName.center}
                                  />
                                )}
                                {item !== 'left' && (
                                  <FixIcon
                                    icon={
                                      <Icon
                                        type="vertical-align-top"
                                        onClick={() => handleGroup(item, 'left', col, index)}
                                      />
                                    }
                                    title={groupName.left}
                                    config={{
                                      placement: 'topRight',
                                    }}
                                  />
                                )}
                                {item !== 'right' && (
                                  <FixIcon
                                    icon={
                                      <Icon
                                        type="vertical-align-bottom"
                                        onClick={() => handleGroup(item, 'right', col, index)}
                                      />
                                    }
                                    title={groupName.right}
                                    config={{
                                      placement: 'topRight',
                                    }}
                                  />
                                )}
                              </div>
                            </div>
                          )}
                        </Draggable>
                      );
                    })}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </Fragment>
          ))}
        </DragDropContext>
      </div>
    </div>
  );
};

export default Menu;
